// Module
var code = `<customer-breadcrumbs></customer-breadcrumbs>
<customer-profile-header></customer-profile-header>
<section class="box">
  <sub-header header="'Issue certificate'"></sub-header>

    <!-- Product information -->
    <div class="info info--deposit">
      <div class="info-detail">
        <span class="key">Product name:</span>
        <span class="value">{{\$ctrl.product.productName}}</span>
      </div>
      <div class="info-detail">
        <span class="key">Available balance:</span>
        <span class="value">{{\$ctrl.product.balance | nxCurrency}}</span>
      </div>
    </div>

    <div
      class="alert"
      ng-if="\$ctrl.depositType.certificateNumberStrategy === 'AUTOMATIC'">
      CTD number will be generated automatically
    </div>

    <form name="\$ctrl.transactionForm">
      <table class="misc-transaction__table table">
        <tbody>
          <tr ng-if="\$ctrl.activeCertificate">
            <td></td>
            <td>Active CTD number:</td>
            <td>
              <input
                disabled
                class="value"
                type="text"
                ng-model="\$ctrl.activeCertificate.number"
              />
            </td>
          </tr>
          <tr ng-if="\$ctrl.depositType.certificateNumberStrategy === 'MANUAL'">
            <td></td>
            <td>CTD number:</td>
            <td>
              <input
                class="value"
                type="text"
                required
                ng-model="\$ctrl.certificate.number"
                maxlength="32"/>
            </td>
          </tr>
        </tbody>
      </table>

      <div class="buttons">
        <button
          type="button"
          class="btn btn-warning"
          ng-click="\$ctrl.redirectBack()">
          Cancel
        </button>
        <button
          type="button"
          class="btn btn-success"
          ng-click="\$ctrl.issueCertificate()"
          ng-disabled="\$ctrl.transactionForm.\$invalid">
          Issue
        </button>
      </div>

    </form>
</section>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/term-deposits/issue-certificate/issue-certificate.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;